/* eslint-disable @typescript-eslint/no-namespace */
import { LiveDTO } from '@app/modules/live/dtos/live';
import { BehaviorSubject } from 'rxjs';
import { SettingsDTO } from './settings-dto';
import { ValueTypes } from '@app/core/constants/global-enum';


export namespace SettingsModel {

    export abstract class Utils {

        public static resolveValue<T>(val: any, valueType: ValueTypes): T {
            switch (+valueType) {
                case ValueTypes.Number:
                case ValueTypes.Currency:
                    return (+val) as unknown as T; // cast number
                case ValueTypes.Boolean:
                    return (val?.toLowerCase() === 'true') as unknown as T; //cast boolean
                case ValueTypes.DateTime:
                    return new Date(val) as unknown as T; //cast date
                case ValueTypes.WeeklySchedule:
                    try {
                        return JSON.parse(val) as unknown as T; // parse JSON for WeeklySchedule
                    } catch {
                        return val as unknown as T; // fallback to raw value
                    }
                case ValueTypes.String:
                case ValueTypes.String:
                case ValueTypes.Password:
                case ValueTypes.Color:
                case ValueTypes.PhotoUrl:
                case ValueTypes.Link:
                default:
                    return val as unknown as T; // vat ken ay du sam tayms

            }
        }
    }

    export class ReferenceTableData {
        table: string;
        idField: string;
        displayField: string;
    }


    export class UserSetting {
        id?: string;
        settingId: string;
        userId?: string;

        _primaryValue: any;
        public get primaryValue(): any {
            return this._primaryValue;
        }

        public set primaryValue(val: any) {
            this._primaryValue = val;
        }

        constructor(settingId: string, source?: SettingsDTO.UserSettings) {
            this.settingId = settingId;
            if (source) {
                this.id = source.id;
                this.userId = source.userId;
            }
        }

        public setIntialValue(primaryValue: any): void {
            this._primaryValue = primaryValue;
        }

        getValue<T>(): T {
            return this.primaryValue as T;
        }
    }

    export class Settings {

        public static settingChangedBehavior = new BehaviorSubject<SettingsModel.Settings>(undefined);
        public static settingChanged = this.settingChangedBehavior.asObservable();

        changeRequest: LiveDTO.ChangeRequest;

        id: string;
        primaryKey: string;
        anchorId: string;
        scope: SettingsDTO.SettingScope;
        keyGroupTitle: string;
        keyGroup: string;
        title: string;
        icon: any;
        enabledIcon: any;
        disabledIcon: any;
        description: string;
        shortDescription: string;

        defaultValue: any;
        valueType: ValueTypes;
        additionalData: ReferenceTableData | string;
        displayOrder: number;
        dependentId: string;
        releaseStatus: SettingsDTO.ReleaseStatus;
        browsable: boolean;
        userSetting: UserSetting;
        externalApplicationId?: string;
        externalApplicationName?: string;


        constructor(dto: SettingsDTO.Settings) {
            this.id = dto.id;
            this.primaryKey = dto.primaryKey;
            this.anchorId = dto.primaryKey.replaceAll('.', '-',);
            this.scope = dto.scope;
            this.keyGroupTitle = dto.keyGroupTitle;
            this.keyGroup = dto.keyGroup;

            if (dto.icon) {
                try { this.icon = JSON.parse(dto.icon.replace(/'/g, '"')); } catch { }
            }
            if (dto.enabledIcon) {
                try { this.enabledIcon = JSON.parse(dto.enabledIcon.replace(/'/g, '"')); } catch { }
            }
            if (dto.disabledIcon) {
                try { this.disabledIcon = JSON.parse(dto.disabledIcon.replace(/'/g, '"')); } catch { }
            }

            this.title = dto.title;
            this.description = dto.description;
            this.shortDescription = dto.description.substring(0, 6);

            this.valueType = dto.valueType;
            if (dto.valueType != ValueTypes.Enum) {
                try { this.additionalData = JSON.parse(dto.additionalData); } catch { }
            } else if (dto.valueType == ValueTypes.Enum) {
                this.additionalData = dto.additionalData;
            }

            this.displayOrder = dto.displayOrder;
            this.dependentId = dto.dependentId;

            this.setIntialValue(Utils.resolveValue(dto.primaryValue, this.valueType));

            this.defaultValue = Utils.resolveValue(dto.defaultValue, this.valueType);

            // Initialize userSetting wrapper and values
            this.userSetting = new UserSetting(this.id, dto.userSetting);
            if (dto.scope == SettingsDTO.SettingScope.user && dto.userSetting) {
                // When user-scoped and server provided a userSetting, seed from it
                this.userSetting.setIntialValue(Utils.resolveValue(dto.userSetting.primaryValue, this.valueType));
                this.setIntialValue(Utils.resolveValue(dto.userSetting.primaryValue, this.valueType));
            } else {
                // For system-scoped or if no userSetting exists yet, initialize userSetting with current primary
                this.userSetting.setIntialValue(this.primaryValue);
            }

            this.releaseStatus = dto.releaseStatus;
            this.browsable = dto.browsable;
            this.externalApplicationId = dto.externalApplicationId;
            this.externalApplicationName = dto.externalApplicationName;
        }

        _primaryValue: any;
        public get primaryValue(): any {
            return this._primaryValue;
        }

        public set primaryValue(val: any) {
            let changed = false;


            if (this._primaryValue !== val) { changed = true; }

            this._primaryValue = val;

            if (changed) {
                Settings.settingChangedBehavior.next(this);
            }
        }

        public setIntialValue(primaryValue: any): void {
            this._primaryValue = primaryValue;
        }

        getValue<T>(): T {
            return this.primaryValue as T;
        }

    }
}
